export default process.env.NODE_ENV === "development"
  ? "http://localhost:5000"
  : "https://ep1e8nn6s1.execute-api.eu-west-2.amazonaws.com";
